import { getPageConfigDataByKey, getInstanceRegistryByKey } from '../';
import Proctor from '../../proctor';

export const getProctor = (): Proctor => {
    const proctor = getInstanceRegistryByKey('proctor', undefined);

    if (proctor) {
        return proctor;
    }

    throw new Error('Proctor is not defined. Something may have gone wrong in initialization');
};

// This is only used for logging...
export const getMobileAppProctorGrps = () => getPageConfigDataByKey('mobileProctorGrps', 'NaN');
